import React, { useEffect, useState } from "react";

import { ToastError, ToastSuccess } from "src/component/uiElements/toast";
import { LOGOUT } from "src/component/helper/constants";
import {
    SelectOwner as SELECT_OWNER_INFO,
    SelectMultipleFiles as SELECT_FILES,
    SelectResidentialDetails as SELECT_RESI_DETAILS,
    SelectPropertySpecification as SELECT_PROPERTY_SPECI,
    SelectFinancialDetails as SELECT_FINANCIAL_DETAILS,
    SelectedAmenities as SELECTED_AMENITIES,
} from 'src/component/api/residentialProperty/ResidentialPropertyAPI';


const UseRecidentialPropertyInformation = (list: any) => {
    const [financialDetails, setFinancialDetails] = useState<any>(null);
    const [OwnersDetails, setOwnersDetails] = useState<any>(null);
    const [propertyDetails, setPropertyDetails] = useState<any>(null);
    const [specificationDetails, setSpecificationDetails] = useState<any>(null);
    const [amenitiesDetails, setAmenitiesDetails] = useState<any>(null);
    const [mediaDetails, setMediaDetails] = useState<any>(null);


    useEffect(() => {
        SelectOwnerInfo(list);
        SelectResidentialDetails(list);
        SelectPropertySpecification(list);
        SelectFinancialDetails(list);
        SelectedAmenities(list);
        SelectUploadedImages(list);
    }, []);


    const SelectUploadedImages = async (list: any) => {
        let inputObj = {
            UserID: list.UserID,
        };

        let request = JSON.stringify(inputObj);
        var response = await SELECT_FILES(request);
        if (!response?.isAuthorized) LOGOUT();

        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }

        var data = JSON.parse(response?.data!);
        setMediaDetails(data);

    };

    const SelectPropertySpecification = async (list: any) => {
        let inputObj = {
            UserID: list.UserID,
        };

        let request = JSON.stringify(inputObj);
        var response = await SELECT_PROPERTY_SPECI(request);
        if (!response?.isAuthorized) LOGOUT();

        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }

        var data = JSON.parse(response?.data!);
        setSpecificationDetails(data);
    };

    const SelectResidentialDetails = async (list: any) => {
        let inputObj = {
            UserID: list.UserID,
        };

        let request = JSON.stringify(inputObj);
        var response = await SELECT_RESI_DETAILS(request);
        if (!response?.isAuthorized) LOGOUT();

        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }

        var data = JSON.parse(response?.data!);
        setPropertyDetails(data);
    };


    const SelectedAmenities = async (list: any) => {
        let inputObj = {
            UserID: list.UserID,
        };

        let request = JSON.stringify(inputObj);
        var response = await SELECTED_AMENITIES(request);

        if (!response?.isAuthorized) LOGOUT();

        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }

        var data = JSON.parse(response?.data!);

        setAmenitiesDetails(data);
    };
    const SelectOwnerInfo = async (list: any) => {
        let inputObj = {
            UserID: list.UserID,
        };

        let request = JSON.stringify(inputObj);
        var response = await SELECT_OWNER_INFO(request);
        if (!response?.isAuthorized) LOGOUT();

        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }

        var data = JSON.parse(response?.data!);

        setOwnersDetails(data);
    };


    const SelectFinancialDetails = async (list: any) => {
        let inputObj = {
            UserID: list.UserID,
        };

        let request = JSON.stringify(inputObj);
        var response = await SELECT_FINANCIAL_DETAILS(request);
        if (!response?.isAuthorized) LOGOUT();

        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }

        var data = JSON.parse(response?.data!);
        setFinancialDetails(data);
    };

    return {
        financialDetails,
        OwnersDetails,
        propertyDetails,
        amenitiesDetails,
        mediaDetails,
        specificationDetails
    };
};

export default UseRecidentialPropertyInformation;
